/**
 * MyNestBox Theme JavaScript
 * Scroll animations, header behavior, newsletter
 */

(function() {
  'use strict';

  // ---- Scroll-triggered animations (Intersection Observer) ----
  const animateElements = document.querySelectorAll('.animate-in');

  if (animateElements.length > 0) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -50px 0px', threshold: 0.1 });

    animateElements.forEach(el => observer.observe(el));
  }

  // ---- Sticky header scroll effect ----
  const header = document.querySelector('.site-header');
  if (header) {
    window.addEventListener('scroll', () => {
      header.classList.toggle('site-header--scrolled', window.pageYOffset > 10);
    }, { passive: true });
  }
  
// ---- Mobile menu toggle ----
const mobileToggle = document.getElementById('site-header-mobile-toggle');
const mobileNav = document.getElementById('site-header-nav');

if (mobileToggle && mobileNav) {
  const closeMobileNav = () => {
    mobileNav.classList.remove('is-open');
    mobileToggle.classList.remove('is-active');
    mobileToggle.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('overflow-hidden');
  };

  mobileToggle.addEventListener('click', () => {
    const isOpen = mobileNav.classList.toggle('is-open');
    mobileToggle.classList.toggle('is-active', isOpen);
    mobileToggle.setAttribute('aria-expanded', String(isOpen));
    document.body.classList.toggle('overflow-hidden', isOpen);
  });

  mobileNav.querySelectorAll('.site-header__menu-link').forEach((link) => {
    link.addEventListener('click', closeMobileNav);
  });

  document.addEventListener('click', (event) => {
    if (
      mobileNav.classList.contains('is-open') &&
      !mobileNav.contains(event.target) &&
      !mobileToggle.contains(event.target)
    ) {
      closeMobileNav();
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && mobileNav.classList.contains('is-open')) {
      closeMobileNav();
    }
  });
}

  // ---- Newsletter form ----
  const newsletterForm = document.getElementById('NewsletterForm');
  if (newsletterForm) {
    newsletterForm.addEventListener('submit', function() {
      const btn = this.querySelector('.newsletter__btn');
      if (btn) {
        btn.textContent = 'Subscribing...';
        btn.disabled = true;
      }
    });
  }

})();
